var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"total":_vm.total,"deleteable":_vm.$can(_vm.$permissions.PRINTGROUPS_DELETE)},on:{"edit":_vm.edit,"delete":function($event){return _vm.$emit('delete', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }